'use client';

import type { ReactNode } from 'react';
import type {
  NavItem,
  SubNavColumnWidth,
  SubNavCta,
  SubNavPanelStyle,
} from './types';
import { DesktopContentPanel } from './DesktopContentPanel';
import { SubNavFooter } from './SubNavFooter';
import { hasSubNavCtaMessage } from './utils';

interface ColumnsLayoutProps {
  title: string;
  columns: NavItem[];
  cta?: SubNavCta;
  dividedLastColumn?: boolean;
  menuContent?: ReactNode;
  showHeading?: boolean;
  columnWidth?: SubNavColumnWidth;
  panelStyle?: SubNavPanelStyle;
}

export function ColumnsLayout({
  title,
  columns,
  cta,
  dividedLastColumn = false,
  menuContent,
  showHeading,
  columnWidth,
  panelStyle,
}: ColumnsLayoutProps) {
  return (
    <div className='hidden md:flex md:flex-col' data-subnav-layout='columns'>
      <DesktopContentPanel
        heading={title}
        columns={columns}
        dividedLastColumn={dividedLastColumn}
        menu={title}
        menuContent={menuContent}
        showHeading={showHeading}
        columnWidth={columnWidth}
        panelStyle={panelStyle}
      />

      {hasSubNavCtaMessage(cta) && <SubNavFooter cta={cta} />}
    </div>
  );
}
